import { CesiumOverlayComponent } from 'app/agriculture/FarmMain/MapRenderer/components/CesiumOverlayComponent';
import { CesiumPolygonComponent } from 'app/agriculture/FarmMain/MapRenderer/components/CesiumPolygonComponent';
import { CesiumPolylineComponent } from 'app/agriculture/FarmMain/MapRenderer/components/CesiumPolylineComponent';
import { useSelection } from 'app/agriculture/ContextMenu/hooks/useSelection/useSelection';
import { PolygonGeometry } from 'app/agriculture/queries/types/geometry/PolygonGeometry';
import { PrimitiveCollectionProvider } from 'app/agriculture/FarmMain/MapRenderer/context/PrimitiveCollectionContext';
import { PointGeometry } from 'app/agriculture/queries/types/geometry/PointGeometry';
import { geometryToPositions } from 'app/agriculture/FarmMain/MapRenderer/utils/geometryToPositions';

interface PolygonProps {
    id: number | string;
    geometry: PolygonGeometry;
    pole?: PointGeometry;
    image: string | null;
    borderColor: Cesium.Color;
    borderWidth?: number;
    allowPicking?: boolean;
}

export function Polygon({
    id,
    geometry,
    pole,
    image,
    borderColor,
    borderWidth = 2,
    allowPicking = true,
}: PolygonProps) {
    const { isSelected } = useSelection();

    return (
        <PrimitiveCollectionProvider>
            {image == null || pole == null ? null : (
                <CesiumOverlayComponent
                    geometry={geometry}
                    pole={pole}
                    image={image}
                    isSelected={isSelected(id)}
                />
            )}
            <CesiumPolygonComponent
                positions={geometryToPositions(geometry)}
                color={Cesium.Color.BLACK.withAlpha(isSelected(id) ? 0.1 : 0.02)}
                id={id}
                allowPicking={allowPicking}
            />
            <CesiumPolylineComponent
                positions={geometryToPositions(geometry)}
                color={borderColor.withAlpha(isSelected(id) ? 1 : 0.4)}
                id={id}
                width={borderWidth}
            />
        </PrimitiveCollectionProvider>
    );
}
